import { EventEmitter, AfterViewInit, Component, ElementRef, Injector, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { DialogComponent } from '@farris/ui-dialog';

@Component({
    selector: 'lookup-advanced-layout',
    templateUrl: 'lookup-advanced-layout.component.html',
    // styleUrls: ['./advanced-layout.scss'],
    encapsulation: ViewEncapsulation.None
})

export class LookupAdvancedLayoutComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

    @Input() title = 'å¸®å©éæ©å¨'
    @Input() activeTab = 'datalist';
    @Input() enableFav: boolean;

    @Input() dataTab = 'æ°æ®åè¡¨';
    @Input() favTab = 'æ¶èå¤¹'

    @Output() tabChanged = new EventEmitter();
    @Output() close = new EventEmitter();

    @ViewChild('header') headerRel: ElementRef;
    @ViewChild('activetab') activetabRef:ElementRef;

    dialogRef: DialogComponent;
    constructor(public elRef: ElementRef, private injector: Injector, private zone: NgZone, private render2: Renderer2) {
        this.dialogRef = this.injector.get(DialogComponent, null);
    }

    ngOnInit() {
        
    }

    ngOnDestroy(): void {
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.activeTab && !changes.activeTab.isFirstChange()) {
            this.setCurrentTab();
        }
    }

    ngAfterViewInit(): void {
        if (this.dialogRef) {
            this.dialogRef.dragHandle = this.headerRel.nativeElement;
            this.dialogRef.dialogEl.nativeElement.querySelectorAll('.f-search-box .search-input input').forEach(n => n.setAttribute('maxlength', 100));
        }

        this.setCurrentTab();
    }

    private setCurrentTab() {
        if (this.activetabRef) {
            this.render2.setStyle(this.activetabRef.nativeElement, 'transform', `translate3d(${this.activeTab == 'datalist' ? 0: 84}px, 0px, 0px)`);
        }
    }

    changeTabs($event, tabstr) {
        this.activeTab = tabstr;
        this.setCurrentTab();
        this.tabChanged.emit({ tab: tabstr, $event });
    }

    closeDialog($event) {
        if (this.dialogRef) {
            $event.stopPropagation();
            this.dialogRef.close();
        }
    }

    changeDialogSize($event: MouseEvent) {
        if (this.dialogRef) {
            $event.stopPropagation();
            this.dialogRef.changeDialogSize();
        }
    }
}